function showFilters() {
  var filtersTab = document.getElementById("filters-tab");
  var overlay = document.getElementById("overlay-filters");
  var body = document.body;

  console.log("juro", overlay);
  filtersTab.style.display = "flex";
  filtersTab.style.marginRight = "600px";
  overlay.style.backgroundColor = "#000";
  overlay.style.zIndex = 1;
  body.style.overflow = "hidden"; // Disable body scrolling
}
